/**
 * Where a grid column's data comes from (app-language pattern 17, HP-V3/HP-V4, Pedro
 * 2026-10-19): the Securities Master, the uploaded positions file, or the app's own
 * calculation. Shown as a GREY icon (a source is a category, not a state: never a §2 state
 * colour) in the headings, the legend and the Columns list, which can also be narrowed by it.
 */
import { IconCalculator, IconDatabase, IconFileSpreadsheet } from '@tabler/icons-react';

export type Origin = 'master' | 'file' | 'calc';

export const ORIGINS: Record<Origin, { icon: typeof IconDatabase; text: string; short: string }> = {
  master: { icon: IconDatabase, text: 'From the Securities Master', short: 'Securities Master' },
  file: { icon: IconFileSpreadsheet, text: 'From the uploaded positions file', short: 'Positions file' },
  calc: { icon: IconCalculator, text: 'Calculated by the app', short: 'Calculated' },
};
export const ORIGIN_ORDER: Origin[] = ['master', 'file', 'calc'];
export const ORIGIN_COLOR = 'var(--mantine-color-gray-6)';
